/**
 * Convert memo/rich-text HTML to plain text for substring/quote matching.
 * Mirrors the server-side helpers/html_to_text.js so AI-extracted quotes
 * (built from the stripped server text) line up with what we render here.
 */
export default function stripHtml(html) {
    if (!html) return "";

    // Convert line-break-ish tags to newlines first, matching the server helper.
    const withBreaks = String(html)
        .replace(/<\s*br\s*\/?>/gi, "\n")
        .replace(/<\/(p|div|h[1-6]|li)>/gi, "\n");

    const tmp = document.createElement("div");
    tmp.innerHTML = withBreaks;
    const text = tmp.textContent || tmp.innerText || "";

    return text.replace(/\n{3,}/g, "\n\n").trim();
}
